import React from 'react'
import Input from './Input.jsx'
import PropTypes from 'prop-types'

export default class TextArea extends Input {
  static propTypes = {
    rows: PropTypes.number,
  }

  static defaultProps = {
    rows: 3,
  }

  render () {
    return (
      <div className="input-group">
        <textarea
          rows={this.props.rows}
          name={this.props.name}
          value={this.props.value === null ? '' : this.props.value}
          onChange={this.handleChange}
          className={'form-control ' + this.props.className}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          data-parsley-required={this.props.required}
          data-parsley-errors-messages-disabled
        />
      </div>
    )
  }
}
